import { TextField } from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch, iRootState } from '../redux/store';
import useFormatMessage from '../useFormatMessage';

const FeedbackFromEmailEntry = function FeedbackFromEmailEntry(): React.ReactElement {
  const from = useSelector((state: iRootState) => state.feedback.fromEmail);

  const dispatch = useDispatch<Dispatch>();
  const onChange = function handleOnChange(
    event: React.ChangeEvent<HTMLInputElement>
  ): void {
    dispatch.feedback.changeFromEmail(event.target.value);
  };

  const yourEmail = useFormatMessage({
    id: 'youremailaddressrequired',
    defaultMessage: 'Your Email Address (required)'
  });

  return (
    <TextField
      value={from}
      onChange={onChange}
      label={yourEmail}
      fullWidth
      variant='outlined'
      margin='dense'
      inputProps={{ maxLength: 254 }}
    />
  );
};

export default FeedbackFromEmailEntry;
